export default __webpack_public_path__ + "static/media/checkmark-icon.52605925.svg";